module.exports = __webpack_public_path__ + "static/media/firstImage.cc393eb8.png";